import styled, { css } from "styled-components";

interface IContainer {
  isContentScreen: boolean;
  isProductBundleScreen: boolean;
  isCourseLandingPageCard: boolean;
  isCourseLandingPageFooter: boolean;
}

export const Container = styled.div<IContainer>`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;

  ${({ isProductBundleScreen }) =>
    isProductBundleScreen &&
    css`
      max-width: 19rem;
      flex-direction: column-reverse;
    `}

  ${({ isCourseLandingPageFooter }) =>
    isCourseLandingPageFooter &&
    css`
      flex-direction: row;
      justify-content: center;
    `}

  .price {
    font-weight: bold;
    font-size: ${({ isCourseLandingPageFooter }) =>
      !isCourseLandingPageFooter && "2.2rem"};
    color: ${({ theme }) => theme.colors.textColor};
  }

  .prices-plus-info {
    width: 100%;
    display: flex;
    flex-direction: column;

    ${({ isCourseLandingPageFooter, isProductBundleScreen }) =>
      (isCourseLandingPageFooter || isProductBundleScreen) &&
      css`
        order: 2;
        width: fit-content;
      `}

    h5 {
      font-size: 16px;
      font-weight: 400;
      margin-bottom: 12px;
      color: ${({ theme }) => theme.colors.textColor} !important;
    }

    span {
      color: #999;
      font-weight: 300;
    }

    .starting-at {
      font-size: 15.5px;
    }

    .outside-footer {
      font-weight: 400;
      margin-bottom: 2px;
    }

    .month {
      font-size: 17px;
    }

    ${({ isContentScreen }) =>
      isContentScreen &&
      css`
        h5.label,
        .starting-at {
          color: #fff !important;
          text-align: center;
        }
      `}
  }

  .prices {
    width: 100%;
    display: flex;
    flex-flow: wrap;
    align-items: center;

    h5 {
      margin: 0;
      font-size: 25px;
    }

    .price {
      margin-right: 7px;
      line-height: 1.3;
    }

    ${({ isContentScreen }) =>
      isContentScreen &&
      css`
        justify-content: center;

        span {
          color: #fff;
        }
      `}

    ${({ isProductBundleScreen }) =>
      isProductBundleScreen &&
      css`
        flex-direction: column;
      `}

    ${({ isCourseLandingPageFooter }) =>
      isCourseLandingPageFooter &&
      css`
        margin-bottom: 0;
        width: fit-content;
        flex-direction: column;
        align-items: flex-start;

        h5 {
          font-size: 16px;
        }

        .price {
          margin-right: 0;
        }
      `}
  }

  button {
    width: 100%;
    margin: 0;

    ${({ isCourseLandingPageFooter }) =>
      isCourseLandingPageFooter &&
      css`
        flex: 1;
        margin-right: 10px;
      `}
  }

  button.buy-btn {
    color: ${({ theme }) => theme.colors.btnTextColor} !important;

    &:hover {
      color: ${({ theme }) => theme.colors.btnTextColor} !important;
      opacity: 0.8;
    }
  }
`;
